import { Spotlight } from '@atlaskit/onboarding';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';
import type { SpotlightProps } from './types.tsx';

export const ChoreographerSpotlight = withChoreographedRender<SpotlightProps>(Spotlight);
